import { render, staticRenderFns } from "./RealTimeChannelMonitor.view.vue?vue&type=template&id=5e1d83a5&scoped=true"
import script from "./RealTimeChannelMonitor.view.vue?vue&type=script&lang=ts"
export * from "./RealTimeChannelMonitor.view.vue?vue&type=script&lang=ts"
import style0 from "./RealTimeChannelMonitor.view.vue?vue&type=style&index=0&id=5e1d83a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d83a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VRow,VSnackbar})
